// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"3ebdc39f","274":"7c3f23f5"}[chunkId] + ".chunk.js";
};